import styled from 'styled-components/macro';
import clone from '../../assets/icons/clone.svg';

export const Wrapper = styled.div`
  border: 2px solid #ced5de;
  padding: 12px;
  border-radius: 12px;
  background-color: #ffffff;
  display: flex;
  flex-direction: column;
`;

export const CopyIcon = styled.img.attrs({
  src: clone,
})`
  width: 16px;
  height: 16px;
  cursor: pointer;
`;
